module.exports = __webpack_public_path__ + "static/media/icon_data_top_main-3.eee83539.psd";